// Official Microsoft Teams logo. Source: SVG Logos (gilbarbara), via Iconify "logos:microsoft-teams".
export function TeamsIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 256 239" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="teams-icon-gradient" x1="17.372%" x2="82.628%" y1="-6.51%" y2="106.51%">
          <stop offset="0%" stopColor="#5a62c3" />
          <stop offset="50%" stopColor="#4d55bd" />
          <stop offset="100%" stopColor="#3940ab" />
        </linearGradient>
      </defs>
      <path
        fill="#5059c9"
        d="M178.563 89.302h66.125c6.248 0 11.312 5.065 11.312 11.312v60.231c0 22.96-18.613 41.574-41.573 41.574h-.197c-22.96.003-41.576-18.607-41.579-41.568V95.215a5.91 5.91 0 0 1 5.912-5.913"
      />
      <circle cx="223.256" cy="50.605" r="26.791" fill="#5059c9" />
      <circle cx="139.907" cy="38.698" r="38.698" fill="#7b83eb" />
      <path
        fill="#7b83eb"
        d="M191.506 89.302H82.355c-6.173.153-11.056 5.276-10.913 11.449v68.697c-.862 37.044 28.445 67.785 65.488 68.692c37.043-.907 66.35-31.648 65.489-68.692v-68.697c.143-6.173-4.74-11.296-10.913-11.449"
      />
      <path
        opacity=".1"
        d="M142.884 89.302v96.268a10.96 10.96 0 0 1-6.787 10.062c-1.3.55-2.697.833-4.108.833H76.68c-.774-1.965-1.488-3.93-2.084-5.953a72.5 72.5 0 0 1-3.155-21.076v-68.703c-.143-6.163 4.732-11.278 10.895-11.43z"
      />
      <path
        opacity=".2"
        d="M136.93 89.302v102.222c0 1.411-.283 2.808-.833 4.108a10.96 10.96 0 0 1-10.062 6.787H79.48c-1.012-1.965-1.965-3.93-2.798-5.954a59 59 0 0 1-2.084-5.953a72.5 72.5 0 0 1-3.155-21.076v-68.703c-.143-6.163 4.732-11.278 10.895-11.43z"
      />
      <path
        opacity=".2"
        d="M136.93 89.302v90.315c-.045 5.998-4.896 10.85-10.895 10.895H74.597a72.5 72.5 0 0 1-3.155-21.076v-68.703c-.143-6.163 4.732-11.278 10.895-11.43z"
      />
      <path
        opacity=".2"
        d="M130.977 89.302v90.315c-.046 5.998-4.897 10.85-10.895 10.895H74.597a72.5 72.5 0 0 1-3.155-21.076v-68.703c-.143-6.163 4.732-11.278 10.895-11.43z"
      />
      <path
        opacity=".1"
        d="M142.884 58.523v18.753c-1.012.06-1.965.12-2.977.12s-1.965-.06-2.977-.12a32.7 32.7 0 0 1-5.953-.952a38.7 38.7 0 0 1-26.791-22.742a33 33 0 0 1-1.905-5.954h29.708c6.007.023 10.872 4.887 10.895 10.895"
      />
      <path
        opacity=".2"
        d="M136.93 64.476v12.8a32.7 32.7 0 0 1-5.953-.952a38.7 38.7 0 0 1-26.79-22.742h21.848c6.008.022 10.872 4.887 10.895 10.894"
      />
      <path
        opacity=".2"
        d="M136.93 64.476v12.8a32.7 32.7 0 0 1-5.953-.952a38.7 38.7 0 0 1-26.79-22.742h21.848c6.008.022 10.872 4.887 10.895 10.894"
      />
      <path
        opacity=".2"
        d="M130.977 64.476v11.848a38.7 38.7 0 0 1-26.791-22.743h15.896c6.008.023 10.872 4.888 10.895 10.895"
      />
      <path
        fill="url(#teams-icon-gradient)"
        d="M10.913 53.581h109.15c6.028 0 10.914 4.886 10.914 10.913v109.151c0 6.027-4.886 10.913-10.913 10.913H10.913C4.886 184.558 0 179.672 0 173.645V64.495C0 58.466 4.886 53.58 10.913 53.58"
      />
      <path fill="#fff" d="M94.208 95.125h-21.82v59.416H58.487V95.125H36.769V83.599h57.439z" />
    </svg>
  );
}
